import { FC } from 'react';
import { IconType } from 'react-icons';
import { IoGlobeOutline, IoLogoFacebook, IoLogoLinkedin, IoLogoTwitter, IoLogoYoutube } from 'react-icons/io5';

import { ActionIcon, Button, Group, GroupProps, Tooltip } from '@mantine/core';

import { CompanyProfile } from 'models';

import { InternalTrackingService } from 'services/InternalTrackingService';

const socialLinks: Record<string, { icon: IconType; label: string }> = {
    website: { icon: IoGlobeOutline, label: 'Visit website' },
    linkedin: { icon: IoLogoLinkedin, label: 'Follow on LinkedIn' },
    youtube: { icon: IoLogoYoutube, label: 'Watch on YouTube' },
    facebook: { icon: IoLogoFacebook, label: 'Follow on Facebook' },
    twitter: { icon: IoLogoTwitter, label: 'Follow on Twitter' },
};

const Socials: FC<{ company: CompanyProfile; asButtons?: boolean } & GroupProps> = ({
    company,
    asButtons,
    ...props
}) => {
    const socials = { website: company.website, ...company.socials };

    return (
        <Group gap="xs" {...props}>
            {Object.entries(socials).map(([socialKey, socialUrl]) => {
                const socialLink = socialLinks[socialKey];

                if (!socialUrl || !socialLink) return null;

                const { icon: Icon, label } = socialLink;
                const linkProps = {
                    href: socialUrl,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    ...InternalTrackingService.link(`company.social.${socialKey}`, label),
                };

                if (asButtons) {
                    return (
                        <Button
                            key={socialKey}
                            component="a"
                            size="sm"
                            variant="default"
                            leftSection={<Icon size={16} />}
                            {...linkProps}
                        >
                            {label}
                        </Button>
                    );
                }

                return (
                    <Tooltip key={socialKey} label={label} withArrow>
                        <ActionIcon component="a" size={36} variant="default" aria-label={label} {...linkProps}>
                            <Icon size={18} />
                        </ActionIcon>
                    </Tooltip>
                );
            })}
        </Group>
    );
};

export { Socials };
